import React, { FC } from "react";
import CityLocations from "./CityLocations";

interface Props {
  data: any;
}

const Contact: FC<Props> = ({ data }) => {
  return (
    <>
      <main id="main">
        <div className="container">
          <div className="contactus-page">
            <section
              id="contact_us"
              className="contact-us page-top-padding"
            ></section>

            <section
              className="section-with-background contactus-locations-sec mb-3"
              style={{
                backgroundImage: `url(${data?.elements?.background_img?.value[0]?.url})`,
              }}
            >
              <div className="container">
                <div className="d-block md-hidden">
                  <div className="row ">
                    <div className="col-lg-2  col-xs-12">
                      <div className="header-content">
                        <h2>
                          {data?.elements?.we_unfold?.value.replace(
                            /(<([^>]+)>)/gi,
                            ""
                          )}
                        </h2>
                      </div>
                    </div>
                    <div className="col-lg-10  col-xs-12 ">
                      <CityLocations data={data} />
                    </div>
                  </div>
                </div>
                <div className="d-none md-block">
                  <div className="header-content">
                    <h2>
                      {data?.elements?.we_unfold?.value.replace(
                        /(<([^>]+)>)/gi,
                        ""
                      )}
                    </h2>
                  </div>
                  <div className="row ">
                    <div className="col-md-12  col-xs-12 ">
                      <CityLocations data={data} />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
    </>
  );
};

export default Contact;
